import { render, staticRenderFns } from "./coreSetups.vue?vue&type=template&id=cbf39b64"
import script from "./coreSetups.vue?vue&type=script&lang=js"
export * from "./coreSetups.vue?vue&type=script&lang=js"
import style0 from "./coreSetups.vue?vue&type=style&index=0&id=cbf39b64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports